import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import analyticsService from "../../services/analytics.service";
import { OnyxPrimaryButton } from "../onyx/OnyxButton";

export const LoginButton = () => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = async () => {
    analyticsService.trackAuth('login_initiated', 'auth0');

    await loginWithRedirect({
      appState: {
        returnTo: window.location.pathname,
      },
      authorizationParams: {
        prompt: 'login',
      },
    });
  };

  return (
    <OnyxPrimaryButton onClick={handleLogin} chevron={false}>
      Log In
    </OnyxPrimaryButton>
  );
};
